// import React, { useEffect, useState } from "react";
// import { FaSearch, FaEye } from "react-icons/fa";
// import { IoClose } from "react-icons/io5";
// import { GiMedicines, GiTestTubes } from "react-icons/gi";
// import { HiOutlineShoppingCart } from "react-icons/hi";
// import { Empty, Modal, Select, Spin, message } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import ConsultationService from "../../../Services/ConsultationService";
// import ClinicService from "../../../Services/ClinicService";
// import DrugServices from "../../../Services/DrugServices";
// import LabOrderService from "../../../Services/LabOrderService";
// import {
//     createCartOrderDtlItem,
//     createCartOrderHdrItem,
//     getCurrentTime,
// } from "../../../Shared/CartHelper";
// import {
//     AddtoCart,
//     ForeignAddtoCart,
//     getCartDetails,
// } from "../../../Redux/actions/cartActions";
// import PrescriptionDetails from "../Appoinments/ViewPrescription/PrescriptionDetails";

// /**
//  * PrescriptionCartOrder
//  *
//  * Renders as the content of the antd <Modal open={presCartMod} onCancel={handlePresCartMod} footer={[]} .../>
//  * used in Medicines.jsx. Since that Modal has no `title` and an empty `footer`, this component owns its
//  * own header (title + close) and footer.
//  *
//  * Flow:
//  * 1. Fetches consultations via ConsultationService.getPrescriptions() for the selected patient.
//  * 2. Selecting a consultation shows its drugPrescription / labPrescription entries, split by
//  *    isAvailableForCart:
//  *      - "Y" items -> "Add to Cart" builds/merges a cart payload and posts it (never replaces
//  *        whatever is already in the cart for the patient).
//  *      - "N" items -> "Send to Pharmacy" / "Send to Lab" open a vendor picker and place the order
//  *        directly with the selected pharmacy/lab via ConsultationService.SharePharmaLabAPI, mirroring
//  *        PrescriptionsList.jsx (medicine) and its lab counterpart.
//  *
//  * ASSUMPTIONS TO VERIFY (marked inline as well):
//  * - DrugServices.fetchDrugList(query) is reused to resolve a catalog match (price + vendor/pharmacyId)
//  *   for a prescribed drug, matched by `code === drugPrescription.drugCode`, falling back to the first result.
//  * - LabOrderService.fetchLabTestList(query) is assumed to exist for the equivalent lab-catalog lookup
//  *   (matched by `labTestId`). Rename this call if the real method differs.
//  * - dispatch(getCartDetails(payload)) is a redux-toolkit async thunk, so `.unwrap()` resolves the fresh
//  *   cart object. If it's a plain thunk instead, swap this for reading `state.cart.cartData` after dispatch.
//  * - Lab cart items use orderType "LAB" (per confirmation), drug items use "DRUG".
//  */

// const AFTER_BEFORE_FOOD_LABEL = {
//     AF: "After Food",
//     BF: "Before Food",
// };

// const getInitials = (name = "") =>
//     name
//         .replace("Dr.", "")
//         .trim()
//         .split(" ")
//         .filter(Boolean)
//         .slice(0, 2)
//         .map((w) => w[0])
//         .join("")
//         .toUpperCase();

// const formatDate = (dateStr) => {
//     if (!dateStr) return "";
//     const parsed = new Date(dateStr.replace(" ", "T"));
//     if (Number.isNaN(parsed.getTime())) return dateStr;
//     return parsed.toLocaleDateString("en-GB", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//     });
// };

// function PrescriptionCartOrder({
//     address = null,
//     onClose = () => {},
//     onCancel = () => {},
// }) {
//     const dispatch = useDispatch();
//     const { selectedPatient } = useSelector((state) => state.patients);
//     const { cartData } = useSelector((state) => state.cart);
//     const loginObj = sessionStorage.getItem("login_result");
//     const loggedUser = loginObj ? JSON.parse(loginObj) : null;

//     const [search, setSearch] = useState("");
//     const [loader, setLoader] = useState(false);
//     const [consultations, setConsultations] = useState([]);
//     const [selectedId, setSelectedId] = useState(null);
//     const [selectedPresc,setSelectedPresc] = useState(null);
//     const [prescView,setPrescView] = useState(false);
//     const [cartLoader, setCartLoader] = useState(false);

//     // Pharmacy (Send to Pharmacy) picker
//     const [pharmaModalOpen, setPharmaModalOpen] = useState(false);
//     const [pharmacyList, setPharmacyList] = useState([]);
//     const [pharmaPayload, setPharmaPayload] = useState({});
//     const [pharmaSendLoader, setPharmaSendLoader] = useState(false);

//     // Lab (Send to Lab) picker
//     const [labModalOpen, setLabModalOpen] = useState(false);
//     const [labList, setLabList] = useState([]);
//     const [labPayload, setLabPayload] = useState({});
//     const [labSendLoader, setLabSendLoader] = useState(false);

//     useEffect(() => {
//         if (!selectedPatient?.patientId) return;
//         fetchPrescriptions();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [selectedPatient?.patientId]);

//     const fetchPrescriptions = async () => {
//         const payload = {
//             patientId: selectedPatient.patientId,
//             detailsYN:"Y"
//             // account_Id: selectedPatient.account_Id,
//             // clinic_Id: selectedPatient.clinic_Id,
//             // status: 1,
//         };

//         setLoader(true);
//         try {
//             const response = await ConsultationService.getPrescriptions(payload);
//             const data = response?.data || [];
//             setConsultations(data);
//             setSelectedId(data?.[0]?.consultationId ?? null);
//         } catch (error) {
//             console.log(error);
//             setConsultations([]);
//             message.error("Unable to fetch prescriptions");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const filteredConsultations = consultations.filter((c) => {
//         if (!search.trim()) return true;
//         const q = search.toLowerCase();
//         return (
//             c.userName?.toLowerCase().includes(q) ||
//             formatDate(c.consultationDate)?.toLowerCase().includes(q) ||
//             String(c.consultationId)?.toLowerCase().includes(q)
//         );
//     });

//     const selectedConsultation = consultations.find((c) => c.consultationId === selectedId);
//     const allMedicines = selectedConsultation?.drugPrescription || [];
//     const allLabTests = selectedConsultation?.labPrescription || [];

//     const cartableMedicines = allMedicines.filter((m) => m.isAvailableForCart === "Y");
//     const nonCartableMedicines = allMedicines.filter((m) => m.isAvailableForCart !== "Y");
//     const cartableLabTests = allLabTests.filter((l) => l.isAvailableForCart === "Y");
//     const nonCartableLabTests = allLabTests.filter((l) => l.isAvailableForCart !== "Y");

//     /* ---------------------------------------------------------------------- */
//     /* Add to Cart (isAvailableForCart === "Y")                               */
//     /* ---------------------------------------------------------------------- */

//     // ASSUMPTION: catalog lookup for a prescribed drug, to get mrp + pharmacyId + drugCategory.
//     const resolveDrugCatalogItem = async (drugItem) => {
//         try {
//             const response = await DrugServices.fetchDrugList(drugItem.drugCode || drugItem.drugName);
//             const list = response?.data?.data || [];
//             return list.find((d) => d.code === drugItem.drugCode) || list[0] || null;
//         } catch (e) {
//             console.log(e);
//             return null;
//         }
//     };

//     // ASSUMPTION: equivalent catalog lookup for a prescribed lab test, to get price + labId + labCategory.
//     // Rename to the real LabOrderService method if this differs.
//     const resolveLabCatalogItem = async (labItem) => {
//         try {
//             const response = await LabOrderService.fetchLabTestList(labItem.labTestId || labItem.labTestName);
//             const list = response?.data?.data || [];
//             return list.find((l) => l.labTestId === labItem.labTestId) || list[0] || null;
//         } catch (e) {
//             console.log(e);
//             return null;
//         }
//     };

//     const buildOrUpdateHdr = (existingHdrs, type, dtlPayloads, vendorAccBranch, consultationId, prescriptionName) => {
//         const now = getCurrentTime();
//         let hdrs = [...existingHdrs];
//         const hdrIndex = hdrs.findIndex((h) => h.orderType === type);

//         if (hdrIndex === -1) {
//             // No header of this type yet — create it from the first item, then append the rest.
//             const [firstDtl, ...restDtl] = dtlPayloads;
//             const newHdr = createCartOrderHdrItem({
//                 Acc_branch: vendorAccBranch,
//                 dtlItem: firstDtl,
//                 account: address,
//                 user: loggedUser.user,
//                 patientId: selectedPatient.patientId,
//                 type,
//             });
//             newHdr.cartOrderDtl = [firstDtl, ...restDtl];
//             newHdr.amount = newHdr.cartOrderDtl.reduce((sum, i) => sum + Number(i.amount), 0);
//             newHdr.paidAmount = newHdr.cartOrderDtl.reduce((sum, i) => sum + Number(i.paidAmount), 0);
//             newHdr.consultationId = consultationId;
//             newHdr.prescriptionName = prescriptionName;
//             hdrs.push(newHdr);
//             return hdrs;
//         }

//         // Merge into existing header: bump quantity if orderCode already present, else push new line.
//         const hdr = { ...hdrs[hdrIndex] };
//         let updatedDtl = [...hdr.cartOrderDtl];

//         dtlPayloads.forEach((newItem) => {
//             const existingIdx = updatedDtl.findIndex((i) => i.orderCode === newItem.orderCode);
//             if (existingIdx !== -1) {
//                 const existing = updatedDtl[existingIdx];
//                 const qty = existing.quantity + 1;
//                 updatedDtl[existingIdx] = {
//                     ...existing,
//                     quantity: qty,
//                     amount: qty * existing.unitPrice,
//                     paidAmount: qty * existing.unitPrice,
//                     orderState: "U",
//                     modifiedDate: now,
//                 };
//             } else {
//                 updatedDtl.push(newItem);
//             }
//         });

//         hdr.cartOrderDtl = updatedDtl;
//         hdr.amount = updatedDtl.reduce((sum, i) => sum + Number(i.amount), 0);
//         hdr.paidAmount = updatedDtl.reduce((sum, i) => sum + Number(i.paidAmount), 0);
//         hdr.modifiedDate = now;
//         hdr.consultationId = consultationId;
//         hdr.prescriptionName = prescriptionName;

//         hdrs[hdrIndex] = hdr;
//         return hdrs;
//     };

//     const handleAddToCart = async () => {
//         if (!selectedPatient) {
//             message.error("Please select a patient");
//             return;
//         }
//         if (!selectedConsultation) {
//             message.info("Please select a prescription first");
//             return;
//         }
//         if (cartableMedicines.length === 0 && cartableLabTests.length === 0) {
//             message.info("No items in this prescription are available to add to cart");
//             return;
//         }

//         setCartLoader(true);
//         try {
//             // 1. Resolve catalog details (price/vendor) for every cartable item.
//             const resolvedDrugs = await Promise.all(cartableMedicines.map(resolveDrugCatalogItem));
//             const resolvedLabs = await Promise.all(cartableLabTests.map(resolveLabCatalogItem));

//             const drugDtlPayloads = [];
//             let unresolvedDrugNames = [];
//             cartableMedicines.forEach((rxItem, idx) => {
//                 const catalogItem = resolvedDrugs[idx];
//                 if (!catalogItem) {
//                     unresolvedDrugNames.push(rxItem.drugName);
//                     return;
//                 }
//                 drugDtlPayloads.push({
//                     dtl: createCartOrderDtlItem({
//                         item: {
//                             code: catalogItem.code,
//                             name: catalogItem.medicineName,
//                             price: catalogItem.mrp,
//                             vendorId: catalogItem.pharmacyId,
//                             drugCategory: catalogItem.drugCategory,
//                         },
//                         type: "DRUG",
//                         patientId: selectedPatient.patientId,
//                         user: loggedUser.user,
//                         cartId: cartData?.cartId,
//                     }),
//                     vendor: { acc_Id: catalogItem.pharmacyId, bran_Id: catalogItem.branchId },
//                 });
//             });

//             const labDtlPayloads = [];
//             let unresolvedLabNames = [];
//             cartableLabTests.forEach((rxItem, idx) => {
//                 const catalogItem = resolvedLabs[idx];
//                 if (!catalogItem) {
//                     unresolvedLabNames.push(rxItem.labTestName);
//                     return;
//                 }
//                 labDtlPayloads.push({
//                     dtl: createCartOrderDtlItem({
//                         item: {
//                             code: catalogItem.code || catalogItem.labTestId,
//                             name: catalogItem.labTestName,
//                             price: catalogItem.mrp || catalogItem.price,
//                             vendorId: catalogItem.labId,
//                             labCategory: catalogItem.labCategory,
//                         },
//                         type: "LAB",
//                         patientId: selectedPatient.patientId,
//                         user: loggedUser.user,
//                         cartId: cartData?.cartId,
//                     }),
//                     vendor: { acc_Id: catalogItem.labId, bran_Id: catalogItem.branchId },
//                 });
//             });

//             if (drugDtlPayloads.length === 0 && labDtlPayloads.length === 0) {
//                 message.error("Could not resolve pricing/vendor for any item in this prescription");
//                 setCartLoader(false);
//                 return;
//             }
//             if (unresolvedDrugNames.length > 0 || unresolvedLabNames.length > 0) {
//                 message.warning(
//                     `Skipped (not found in catalog): ${[...unresolvedDrugNames, ...unresolvedLabNames].join(", ")}`,
//                 );
//             }

//             // 2. Always re-check the patient's current cart right before merging, so we never clobber it.
//             let freshCart = cartData;
//             try {
//                 freshCart = await dispatch(getCartDetails({ patientId: selectedPatient.patientId })).unwrap();
//             } catch (e) {
//                 // Fallback to whatever is already in redux if unwrap() isn't supported by this thunk.
//                 console.log("Falling back to existing redux cart state:", e);
//             }

//             const existingHdrs = freshCart?.cartOrderHdr ? [...freshCart.cartOrderHdr] : [];
//             let updatedHdrs = existingHdrs;
//             const consultationId = selectedConsultation.consultationId;
//             const prescriptionName = selectedConsultation.imageName;

//             if (drugDtlPayloads.length > 0) {
//                 updatedHdrs = buildOrUpdateHdr(
//                     updatedHdrs,
//                     "DRUG",
//                     drugDtlPayloads.map((p) => p.dtl),
//                     drugDtlPayloads[0].vendor,
//                     consultationId,
//                     prescriptionName,
//                 );
//             }
//             if (labDtlPayloads.length > 0) {
//                 updatedHdrs = buildOrUpdateHdr(
//                     updatedHdrs,
//                     "LAB",
//                     labDtlPayloads.map((p) => p.dtl),
//                     labDtlPayloads[0].vendor,
//                     consultationId,
//                     prescriptionName,
//                 );
//             }

//             const grandTotalAmount = updatedHdrs.reduce((sum, hdr) => sum + (hdr?.paidAmount || 0), 0);

//             const payload = {
//                 ...(freshCart || {}),
//                 cartId: freshCart?.cartId,
//                 cartOrderHdr: updatedHdrs,
//                 cartType: freshCart?.cartType ?? 1,
//                 patientId: selectedPatient.patientId,
//                 paymentType: freshCart?.paymentType ?? "",
//                 status: 1,
//                 modifiedDate: getCurrentTime(),
//                 totalAmount: grandTotalAmount,
//             };

//             if (loggedUser?.user?.country === "IN") {
//                 await dispatch(AddtoCart(payload));
//             } else {
//                 await dispatch(ForeignAddtoCart(payload));
//             }
//             await dispatch(getCartDetails({ patientId: selectedPatient.patientId }));
//             message.success("Prescription items added to cart successfully.");
//         } catch (error) {
//             console.log(error);
//             message.error("Unable to add items to cart");
//         } finally {
//             setCartLoader(false);
//         }
//     };

//     /* ---------------------------------------------------------------------- */
//     /* Send to Pharmacy / Send to Lab (isAvailableForCart === "N")            */
//     /* ---------------------------------------------------------------------- */

//     const buildVendorRolePayload = (accountRoleType) => {
//         const p = { accountRoleType, status: 1 };
//         if (loggedUser?.user?.rolecode === "ACCT_ADM") {
//             p.account_Id = loggedUser.user.account_Id;
//         } else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//             p.account_Id = loggedUser.user.account_Id;
//             p.clinic_Id = loggedUser.user.clinic_Id;
//         }
//         return p;
//     };

//     const handleOpenPharmacyPicker = async () => {
//         if (nonCartableMedicines.length === 0) return;
//         try {
//             const response = await ClinicService.getClinicMappedPharmacies(buildVendorRolePayload("pharmacy"));
//             setPharmacyList(response.data);
//             setPharmaModalOpen(true);
//         } catch (e) {
//             console.log(e);
//             message.error("Unable to fetch pharmacies");
//         }
//     };

//     const handleSelectedPharma = (selectedItem) => {
//         const item = pharmacyList.find((p) => p.pharmacyId === selectedItem);
//         if (!item) {
//             message.error("Something went wrong please try after sometime!!");
//             return;
//         }
//         setPharmaPayload({
//             ...item,
//             pharmacyId: item.pharmacyId,
//             pharmacyName: item.pharmacyName,
//             pharmacyMailId: item.pharmacyMailId,
//             pharmacyMobile: item.pharmacyMobile,
//         });
//     };

//     const handleSendToPharmacy = async () => {
//         if (!pharmaPayload?.pharmacyId) {
//             message.error("Please select a pharmacy");
//             return;
//         }
//         setPharmaSendLoader(true);
//         const linkPayload = {
//             consultationId: selectedConsultation.consultationId,
//             patientId: selectedPatient.patientId,
//             userId: loggedUser.user.userId,
//             appointmentId: selectedConsultation.appointmentId,
//             prescriptionShareType: "p",
//             vendorId: pharmaPayload.pharmacyId,
//             vendorName: pharmaPayload.pharmacyName,
//             vendorMailId: pharmaPayload.pharmacyMailId,
//             vendorMobile: pharmaPayload.pharmacyMobile,
//             drugPrescriptionStatus: "Sent",
//             rejectedPharmacyRemarks: null,
//             sourceChannel: loggedUser.user.rolecode === "SUPERADMIN" ? "ADMIN" : "PRACTICEADMIN",
//         };

//         try {
//             const response = await ConsultationService.SharePharmaLabAPI(linkPayload);
//             if (response.data.message !== "Prescription sent successfully") {
//                 message.error("Medicine order is already placed");
//                 return;
//             }
//             message.success(`Medicine order sent to ${linkPayload.vendorName}`);
//             setPharmaModalOpen(false);
//             fetchPrescriptions();
//         } catch (error) {
//             message.error(error?.response?.data?.message || "Something went wrong please try after sometime!!");
//         } finally {
//             setPharmaSendLoader(false);
//         }
//     };

//     const handleOpenLabPicker = async () => {
//         if (nonCartableLabTests.length === 0) return;
//         try {
//             const response = await ClinicService.getClinicMappedLabs(buildVendorRolePayload("lab"));
//             setLabList(response.data);
//             setLabModalOpen(true);
//         } catch (e) {
//             console.log(e);
//             message.error("Unable to fetch labs");
//         }
//     };

//     const handleLabSelect = (selectedItem) => {
//         const item = labList.find((l) => l.labId === selectedItem);
//         if (!item) {
//             message.error("Something went wrong please try after sometime!!");
//             return;
//         }
//         setLabPayload({
//             ...item,
//             labId: item.labId,
//             labName: item.labName,
//             labMailId: item.labMailId,
//             labMobile: item.labMobile,
//         });
//     };

//     const handleSendToLab = async () => {
//         if (!labPayload?.labId) {
//             message.error("Please select a lab");
//             return;
//         }
//         setLabSendLoader(true);
//         const linkPayload = {
//             consultationId: selectedConsultation.consultationId,
//             patientId: selectedPatient.patientId,
//             userId: loggedUser.user.userId,
//             appointmentId: selectedConsultation.appointmentId,
//             prescriptionShareType: "l",
//             vendorId: labPayload.labId,
//             vendorName: labPayload.labName,
//             vendorMailId: labPayload.labMailId,
//             vendorMobile: labPayload.labMobile,
//             labPrescriptionStatus: "Sent",
//             rejectedLabRemarks: null,
//             sourceChannel: loggedUser.user.rolecode === "SUPERADMIN" ? "ADMIN" : "PRACTICEADMIN",
//         };

//         try {
//             const response = await ConsultationService.SharePharmaLabAPI(linkPayload);
//             if (response.data.message !== "Prescription sent successfully") {
//                 message.error("Lab order is already placed");
//                 return;
//             }
//             message.success(`Lab order sent to ${linkPayload.vendorName}`);
//             setLabModalOpen(false);
//             fetchPrescriptions();
//         } catch (error) {
//             message.error(error?.response?.data?.message || "Something went wrong please try after sometime!!");
//         } finally {
//             setLabSendLoader(false);
//         }
//     };

//     const handleViewPrescription = (e,presc) => {
//         e.stopPropagation();
//         setSelectedId(presc.consultationId);
//         setSelectedPresc(presc);
//         setPrescView(true);
//     }

//     const handleClosePrescView = () => {
//         setPrescView(false);
//         setSelectedPresc(null);
//         setSelectedId(null);
//     }

//     /* ---------------------------------------------------------------------- */
//     /* Render                                                                  */
//     /* ---------------------------------------------------------------------- */

//     return (
//         <div className="font-sans">
//             {/* Header */}
//             <h2 className="text-xl font-bold text-[#189FAA]">Your Prescription</h2>
                

//             {/* Search */}
//             <div className="mt-4">
//                 <label className="block text-sm font-semibold text-[#232323] mb-1">
//                     Search Prescription
//                 </label>
//                 <div className="relative">
//                     <input
//                         type="text"
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                         placeholder="Search by doctor name, date or ID..."
//                         className="w-full border rounded-md pl-3 pr-9 py-2 text-sm outline-none placeholder:text-xs placeholder:text-gray-400 focus:border-[#189FAA]"
//                     />
//                     <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
//                 </div>
//             </div>

//             {/* Prescription list */}
//             <div className="mt-3 max-h-56 overflow-y-auto scrollWidth border rounded-md">
//                 {loader ? (
//                     <div className="flex items-center justify-center py-8">
//                         <Spin size="small" tip="Loading" />
//                     </div>
//                 ) : filteredConsultations.length === 0 ? (
//                     <div className="py-6">
//                         <Empty description="No prescriptions found" image={Empty.PRESENTED_IMAGE_SIMPLE} />
//                     </div>
//                 ) : (
//                     filteredConsultations.map((c, idx) => {
//                         const isSelected = c.consultationId === selectedId;
//                         return (
//                             <div
//                                 key={c.consultationId}
//                                 onClick={() => setSelectedId(c.consultationId)}
//                                 className={`flex items-center justify-between gap-3 px-3 py-3 cursor-pointer transition-colors ${
//                                     idx !== filteredConsultations.length - 1 ? "border-b" : ""
//                                 } ${isSelected ? "bg-[#e6f7f8]" : "hover:bg-gray-50"}`}
//                             >
//                                 <div className="flex items-center gap-3 min-w-0">
//                                     <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#189FAA] text-white flex items-center justify-center text-xs font-bold">
//                                         {getInitials(c.userName)}
//                                     </div>
//                                     <div className="min-w-0">
//                                         <p className="text-sm font-semibold text-[#232323] truncate">
//                                             {c.userName}
//                                         </p>
//                                         <p className="text-xs text-gray-400">
//                                             {formatDate(c.consultationDate)} &bull; Consultation ID: {c.consultationId}
//                                         </p>
//                                     </div>
//                                 </div>
//                                 <button
//                                     type="button"
//                                     onClick={(e) => handleViewPrescription(e,c)}
//                                     className="flex-shrink-0 w-8 h-8 rounded-md border border-[#189FAA] text-[#189FAA] flex items-center justify-center hover:bg-[#189FAA] hover:text-white transition-colors"
//                                     aria-label="View prescription"
//                                 >
//                                     <FaEye size={13} />
//                                 </button>
//                             </div>
//                         );
//                     })
//                 )}
//             </div>

//             {/* Medicine and Lab Test — only once a prescription is selected */}
//             {selectedConsultation && (
//                 <>
//                     <h3 className="mt-5 text-base font-bold text-[#189FAA]">Medicine and Lab Test</h3>

//                     {/* Medicine */}
//                     {allMedicines.length > 0 && (
//                         <>
//                             <div className="flex items-center justify-between mt-2">
//                                 <p className="text-sm font-semibold text-[#232323]">Medicine</p>
//                                 {nonCartableMedicines.length > 0 && (
//                                     <button
//                                         type="button"
//                                         onClick={handleOpenPharmacyPicker}
//                                         className="text-[11px] font-semibold text-[#189FAA] underline"
//                                     >
//                                         Send to Pharmacy ({nonCartableMedicines.length})
//                                     </button>
//                                 )}
//                             </div>
//                             <div className="mt-1 border rounded-md divide-y">
//                                 {allMedicines.map((med) => {
//                                     const unavailable = med.isAvailableForCart !== "Y";
//                                     return (
//                                         <div
//                                             key={med.id}
//                                             className={`flex items-center justify-between gap-3 px-3 py-3 ${
//                                                 unavailable ? "opacity-50" : ""
//                                             }`}
//                                         >
//                                             <div className="flex items-center gap-3 min-w-0">
//                                                 <div className="flex-shrink-0 w-9 h-9 rounded-md bg-[#fdeef0] flex items-center justify-center">
//                                                     <GiMedicines className="text-[#c14a5c]" size={18} />
//                                                 </div>
//                                                 <div className="min-w-0">
//                                                     <p className="text-sm font-semibold text-[#232323] truncate">
//                                                         {med.drugName}
//                                                     </p>
//                                                     <p className="text-xs text-gray-400 truncate">
//                                                         {med.composition || "Tablet"}
//                                                         {med.duration ? ` \u2022 ${med.duration} day(s)` : ""}
//                                                     </p>
//                                                     {unavailable && (
//                                                         <p className="text-[10px] text-orange-400 mt-0.5">
//                                                             Send to pharmacy — not directly orderable
//                                                         </p>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                             <div className="flex-shrink-0 text-right">
//                                                 <p className="text-sm font-semibold text-[#189FAA]">{med.dosage}</p>
//                                                 <p className="text-xs text-gray-400">
//                                                     {AFTER_BEFORE_FOOD_LABEL[med.afterBeforeFood] || "-"}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </>
//                     )}

//                     {/* Lab Test */}
//                     {allLabTests.length > 0 && (
//                         <>
//                             <div className="flex items-center justify-between mt-4">
//                                 <p className="text-sm font-semibold text-[#232323]">Lab Test</p>
//                                 {nonCartableLabTests.length > 0 && (
//                                     <button
//                                         type="button"
//                                         onClick={handleOpenLabPicker}
//                                         className="text-[11px] font-semibold text-[#189FAA] underline"
//                                     >
//                                         Send to Lab ({nonCartableLabTests.length})
//                                     </button>
//                                 )}
//                             </div>
//                             <div className="mt-1 border rounded-md divide-y">
//                                 {allLabTests.map((test) => {
//                                     const unavailable = test.isAvailableForCart !== "Y";
//                                     return (
//                                         <div
//                                             key={test.id}
//                                             className={`flex items-center gap-3 px-3 py-3 ${
//                                                 unavailable ? "opacity-50" : ""
//                                             }`}
//                                         >
//                                             <div className="flex-shrink-0 w-9 h-9 rounded-md bg-[#e6f7f8] flex items-center justify-center">
//                                                 <GiTestTubes className="text-[#189FAA]" size={18} />
//                                             </div>
//                                             <div className="min-w-0">
//                                                 <p className="text-sm font-semibold text-[#232323] truncate">
//                                                     {test.labTestName}
//                                                 </p>
//                                                 <p className="text-xs text-gray-400">Lab Test</p>
//                                                 {unavailable && (
//                                                     <p className="text-[10px] text-orange-400 mt-0.5">
//                                                         Send to lab — not directly orderable
//                                                     </p>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </>
//                     )}

//                     {allMedicines.length === 0 && allLabTests.length === 0 && (
//                         <div className="py-6">
//                             <Empty description="No medicine or lab test in this prescription" image={Empty.PRESENTED_IMAGE_SIMPLE} />
//                         </div>
//                     )}
//                 </>
//             )}

//             {/* Footer */}
//             <div className="flex justify-end gap-4 mt-6">
//                 <button
//                     type="button"
//                     onClick={onCancel}
//                     className="px-5 py-2 border border-[#189FAA] font-sans text-sm font-medium text-[#189FAA] rounded-md hover:bg-[#f0fbfc] transition-colors"
//                 >
//                     Cancel
//                 </button>
//                 <button
//                     type="button"
//                     onClick={handleAddToCart}
//                     disabled={
//                         !selectedConsultation ||
//                         cartLoader ||
//                         (cartableMedicines.length === 0 && cartableLabTests.length === 0)
//                     }
//                     className="flex items-center gap-2 px-5 py-2 bg-[#189FAA] font-sans text-sm font-semibold text-white rounded-md hover:bg-[#157e87] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                     <HiOutlineShoppingCart size={16} />
//                     {cartLoader ? "Adding..." : "Add To Cart"}
//                 </button>
//             </div>

//             {/* Prescription view */}
//             <Modal
//                 open={prescView}
//                 onCancel={handleClosePrescView}
//                 style={{
//                 top: 40,
//                 }}
//                 width={"70%"}
//                 footer={null}
//                 destroyOnClose
//             >
//                 <PrescriptionDetails
//                 prescription={selectedPresc}
//                 selectedPatient={selectedPatient}
//                 />
//             </Modal>

//             {/* Send to Pharmacy modal */}
//             <Modal
//                 title={<span className="text-sm font-semibold font-sans text-[#189FAA]">Medicine Order</span>}
//                 open={pharmaModalOpen}
//                 onCancel={() => setPharmaModalOpen(false)}
//                 footer={[]}
//                 destroyOnClose
//             >
//                 <div className="flex gap-2">
//                     <Select className="w-[80%]" placeholder="Select pharmacy" onChange={handleSelectedPharma}>
//                         {pharmacyList?.map((p) => (
//                             <Select.Option key={p.id} value={p.pharmacyId}>
//                                 {p.pharmacyName}
//                             </Select.Option>
//                         ))}
//                     </Select>
//                     <button
//                         onClick={handleSendToPharmacy}
//                         disabled={pharmaSendLoader}
//                         className="p-1 px-3 rounded-md bg-[#189FAA] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50"
//                     >
//                         Send Order
//                     </button>
//                 </div>
//             </Modal>

//             {/* Send to Lab modal */}
//             <Modal
//                 title={<span className="text-sm font-semibold font-sans text-[#189FAA]">Lab Order</span>}
//                 open={labModalOpen}
//                 onCancel={() => setLabModalOpen(false)}
//                 footer={[]}
//                 destroyOnClose
//             >
//                 <div className="flex gap-2">
//                     <Select className="w-[80%]" placeholder="Select lab" onChange={handleLabSelect}>
//                         {labList?.map((l) => (
//                             <Select.Option key={l.id} value={l.labId}>
//                                 {l.labName}
//                             </Select.Option>
//                         ))}
//                     </Select>
//                     <button
//                         onClick={handleSendToLab}
//                         disabled={labSendLoader}
//                         className="p-1 px-3 rounded-md bg-[#189FAA] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50"
//                     >
//                         Send Order
//                     </button>
//                 </div>
//             </Modal>
//         </div>
//     );
// }

// export default PrescriptionCartOrder;

import React, { useEffect, useState } from "react";
import { FaSearch, FaEye } from "react-icons/fa";
import { GiMedicines, GiTestTubes } from "react-icons/gi";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { Empty, Modal, Select, Spin, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import ConsultationService from "../../../Services/ConsultationService";
import ClinicService from "../../../Services/ClinicService";
import DrugServices from "../../../Services/DrugServices";
import LabOrderService from "../../../Services/LabOrderService";
import PharmacyService from "../../../Services/PharmacyService";
import ConsentService from "../../../Services/ConsentService";
import {
    createCartOrderDtlItem,
    createCartOrderHdrItem,
    getCurrentTime,
} from "../../../Shared/CartHelper";
import {
    AddtoCart,
    ForeignAddtoCart,
    getCartDetails,
} from "../../../Redux/actions/cartActions";
import PrescriptionDetails from "../Appoinments/ViewPrescription/PrescriptionDetails";

/**
 * PrescriptionCartOrder
 *
 * Flow:
 * 1. Fetches consultations via ConsultationService.getPrescriptions() for the selected patient.
 * 2. Selecting a consultation shows its drugPrescription / labPrescription entries, split by
 *    isAvailableForCart:
 *      - "Y" items -> "Add to Cart" builds/merges a cart payload and posts it (never replaces
 *        whatever is already in the cart for the patient).
 *      - "N" items -> "Send to Pharmacy" / "Send to Lab" replicate the exact guarded flow from
 *        PrescriptionsList.jsx (medicine) and its lab counterpart:
 *          a. If the patient hasn't given e-prescription-sharing consent, show the consent modal
 *             and stop (don't fetch vendors or open the picker).
 *          b. If an order was already sent for this consultation (status set and not "Decline"/""),
 *             block with "Order is Already Placed" and stop.
 *          c. Otherwise validate there's actually a non-empty dispensed list
 *             (PharmacyService.GetDispensedDrugsDtl / LabOrderService.GetLabTestOrderDtl) before
 *             opening the vendor picker.
 *          d. Sending the order calls ConsultationService.SharePharmaLabAPI with
 *             prescriptionShareType "p"/"l", scoped to the whole consultation (that endpoint isn't
 *             item-level — this mirrors the reference components exactly).
 *
 * ASSUMPTIONS TO VERIFY:
 * - DrugServices.fetchDrugList(query) / LabOrderService.fetchLabTestList(query) are used as the
 *   cart catalog lookups (price + vendor) for "Y" items — rename if the real methods differ.
 * - The consultation objects returned by ConsultationService.getPrescriptions carry
 *   `shareEpresWithPharmacy` / `shareEpresWithDiagnostics` and `drugPrescriptionStatus` /
 *   `labPrescriptionStatus` the same way AppointmentService.AppointmentList's records do. If a
 *   field is missing/undefined here, the corresponding guard is skipped (treated as "no block")
 *   rather than silently failing — double check this is the desired default.
 * - dispatch(getCartDetails(payload)) is a redux-toolkit async thunk (`.unwrap()` used); falls back
 *   to existing redux cart state if that's not supported.
 * - Lab cart items use orderType "LAB" (confirmed), drug items use "DRUG".
 */

const AFTER_BEFORE_FOOD_LABEL = {
    AF: "After Food",
    BF: "Before Food",
};

const getInitials = (name = "") =>
    name
        .replace("Dr.", "")
        .trim()
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase();

const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const parsed = new Date(dateStr.replace(" ", "T"));
    if (Number.isNaN(parsed.getTime())) return dateStr;
    return parsed.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

// Treat a status as "already sent" only if it's set to something other than empty/"Decline".
const isOrderAlreadySent = (status) => Boolean(status) && status !== "Decline" && status !== "";

function PrescriptionCartOrder({
    address = null,
    onClose = () => {},
    handleClosePrescOrdMod,
}) {
    const dispatch = useDispatch();
    const { selectedPatient } = useSelector((state) => state.patients);
    const { cartData } = useSelector((state) => state.cart);
    const loginObj = sessionStorage.getItem("login_result");
    const loggedUser = loginObj ? JSON.parse(loginObj) : null;

    const [search, setSearch] = useState("");
    const [loader, setLoader] = useState(false);
    const [consultations, setConsultations] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedPresc, setSelectedPresc] = useState(null);
    const [prescView, setPrescView] = useState(false);
    const [cartLoader, setCartLoader] = useState(false);

    // Pharmacy (Send to Pharmacy) picker
    const [pharmaModalOpen, setPharmaModalOpen] = useState(false);
    const [pharmacyList, setPharmacyList] = useState([]);
    const [pharmaPayload, setPharmaPayload] = useState({});
    const [pharmaSendLoader, setPharmaSendLoader] = useState(false);
    const [pharmaCheckLoader, setPharmaCheckLoader] = useState(false);

    // Lab (Send to Lab) picker
    const [labModalOpen, setLabModalOpen] = useState(false);
    const [labList, setLabList] = useState([]);
    const [labPayload, setLabPayload] = useState({});
    const [labSendLoader, setLabSendLoader] = useState(false);
    const [labCheckLoader, setLabCheckLoader] = useState(false);

    // Consent (shared by both pharmacy/lab flows, like the reference components)
    const [showConsent, setShowConsent] = useState(false);
    const [consentTarget, setConsentTarget] = useState(null); // "pharmacy" | "lab"
    const [consentBtnDisable, setConsentBtnDisable] = useState(false);

    useEffect(() => {
        if (!selectedPatient?.patientId) return;
        fetchPrescriptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedPatient?.patientId]);

    const fetchPrescriptions = async () => {
        const payload = {
            patientId: selectedPatient.patientId,
            detailsYN: "Y",
        };

        setLoader(true);
        try {
            const response = await ConsultationService.getPrescriptions(payload);
            const data = response?.data || [];
            setConsultations(data);
            setSelectedId((prevId) =>
                data.some((c) => c.consultationId === prevId) ? prevId : data?.[0]?.consultationId ?? null,
            );
        } catch (error) {
            console.log(error);
            setConsultations([]);
            message.error("Unable to fetch prescriptions");
        } finally {
            setLoader(false);
        }
    };

    const filteredConsultations = consultations.filter((c) => {
        if (!search.trim()) return true;
        const q = search.toLowerCase();
        return (
            c.userName?.toLowerCase().includes(q) ||
            formatDate(c.consultationDate)?.toLowerCase().includes(q) ||
            String(c.consultationId)?.toLowerCase().includes(q)
        );
    });

    const selectedConsultation = consultations.find((c) => c.consultationId === selectedId);
    const allMedicines = selectedConsultation?.drugPrescription || [];
    const allLabTests = selectedConsultation?.labPrescription || [];

    const cartableMedicines = allMedicines.filter((m) => m.isAvailableForCart === "Y");
    const nonCartableMedicines = allMedicines.filter((m) => m.isAvailableForCart !== "Y");
    const cartableLabTests = allLabTests.filter((l) => l.isAvailableForCart === "Y");
    const nonCartableLabTests = allLabTests.filter((l) => l.isAvailableForCart !== "Y");

    /* ---------------------------------------------------------------------- */
    /* Add to Cart (isAvailableForCart === "Y")                               */
    /* ---------------------------------------------------------------------- */

    const resolveDrugCatalogItem = async (drugItem) => {
        const payload = { status:1}
        if(drugItem.drugName) payload.medicineName = drugItem.drugName;
        if(drugItem.drugCode) payload.drugId = drugItem.drugCode;
        try {
            const response = await DrugServices.prescOrdDrugMdm(payload);
            const list = response?.data?.data || [];
            return list.find((d) => d.code === drugItem.drugCode) || list[0] || null;
        } catch (e) {
            console.log(e);
            return null;
        }
    };

    const resolveLabCatalogItem = async (labItem) => {
        const payload = {status:1}
        // if(labItem.labTestId) payload.labCode = labItem.labTestId;
        if(labItem.labTestName) payload.testName = labItem.labTestName;
        try {
            const response = await ConsultationService.presOrdLabMdm(payload);
            const list = response?.data?.data || [];
            return list.find((l) => l.labTestId === labItem.labTestId) || list[0] || null;
        } catch (e) {
            console.log(e);
            return null;
        }
    };

    const buildOrUpdateHdr = (existingHdrs, type, dtlPayloads, vendorAccBranch, consultationId, prescriptionName) => {
        const now = getCurrentTime();
        let hdrs = [...existingHdrs];
        const hdrIndex = hdrs.findIndex((h) => h.orderType === type);

        if (hdrIndex === -1) {
            const [firstDtl, ...restDtl] = dtlPayloads;
            const newHdr = createCartOrderHdrItem({
                Acc_branch: vendorAccBranch,
                dtlItem: firstDtl,
                account: address,
                user: loggedUser.user,
                patientId: selectedPatient.patientId,
                type,
            });
            newHdr.cartOrderDtl = [firstDtl, ...restDtl];
            newHdr.amount = newHdr.cartOrderDtl.reduce((sum, i) => sum + Number(i.amount), 0);
            newHdr.paidAmount = newHdr.cartOrderDtl.reduce((sum, i) => sum + Number(i.paidAmount), 0);
            newHdr.consultationId = consultationId;
            newHdr.prescriptionName = prescriptionName;
            hdrs.push(newHdr);
            return hdrs;
        }

        const hdr = { ...hdrs[hdrIndex] };
        let updatedDtl = [...hdr.cartOrderDtl];

        dtlPayloads.forEach((newItem) => {
            const existingIdx = updatedDtl.findIndex((i) => i.orderCode === newItem.orderCode);
            if (existingIdx !== -1) {
                const existing = updatedDtl[existingIdx];
                const qty = existing.quantity + 1;
                updatedDtl[existingIdx] = {
                    ...existing,
                    quantity: qty,
                    amount: qty * existing.unitPrice,
                    paidAmount: qty * existing.unitPrice,
                    orderState: "U",
                    modifiedDate: now,
                };
            } else {
                updatedDtl.push(newItem);
            }
        });

        hdr.cartOrderDtl = updatedDtl;
        hdr.amount = updatedDtl.reduce((sum, i) => sum + Number(i.amount), 0);
        hdr.paidAmount = updatedDtl.reduce((sum, i) => sum + Number(i.paidAmount), 0);
        hdr.modifiedDate = now;
        hdr.consultationId = consultationId;
        hdr.prescriptionName = prescriptionName;

        hdrs[hdrIndex] = hdr;
        return hdrs;
    };

    const handleAddToCart = async () => {
        if (!selectedPatient) {
            message.error("Please select a patient");
            return;
        }
        if (!selectedConsultation) {
            message.info("Please select a prescription first");
            return;
        }
        if (cartableMedicines.length === 0 && cartableLabTests.length === 0) {
            message.info("No items in this prescription are available to add to cart");
            return;
        }

        setCartLoader(true);
        try {
            const resolvedDrugs = await Promise.all(cartableMedicines.map(resolveDrugCatalogItem));
            const resolvedLabs = await Promise.all(cartableLabTests.map(resolveLabCatalogItem));

            const drugDtlPayloads = [];
            let unresolvedDrugNames = [];
            cartableMedicines.forEach((rxItem, idx) => {
                const catalogItem = resolvedDrugs[idx];
                if (!catalogItem) {
                    unresolvedDrugNames.push(rxItem.drugName);
                    return;
                }
                drugDtlPayloads.push({
                    dtl: createCartOrderDtlItem({
                        item: {
                            code: catalogItem.code,
                            name: catalogItem.medicineName,
                            price: catalogItem.mrp,
                            vendorId: catalogItem.pharmacyId,
                            drugCategory: catalogItem.drugCategory,
                        },
                        type: "DRUG",
                        patientId: selectedPatient.patientId,
                        user: loggedUser.user,
                        cartId: cartData?.cartId,
                    }),
                    vendor: { acc_Id: catalogItem.pharmacyId, bran_Id: catalogItem.branchId },
                });
            });

            const labDtlPayloads = [];
            let unresolvedLabNames = [];
            cartableLabTests.forEach((rxItem, idx) => {
                const catalogItem = resolvedLabs[idx];
                if (!catalogItem) {
                    unresolvedLabNames.push(rxItem.labTestName);
                    return;
                }
                labDtlPayloads.push({
                    dtl: createCartOrderDtlItem({
                        item: {
                            code: catalogItem.testCode,
                            name: catalogItem.testName,
                            price: catalogItem.listPrice,
                            vendorId: catalogItem.labCode,
                            labCategory: catalogItem.testType,
                        },
                        type: "LAB",
                        patientId: selectedPatient.patientId,
                        user: loggedUser.user,
                        cartId: cartData?.cartId,
                    }),
                    vendor: { acc_Id: catalogItem.labCode, bran_Id: catalogItem.branchId },
                });
            });

            if (drugDtlPayloads.length === 0 && labDtlPayloads.length === 0) {
                message.error("Could not resolve pricing/vendor for any item in this prescription");
                setCartLoader(false);
                return;
            }
            if (unresolvedDrugNames.length > 0 || unresolvedLabNames.length > 0) {
                message.warning(
                    `Skipped (not found in catalog): ${[...unresolvedDrugNames, ...unresolvedLabNames].join(", ")}`,
                );
            }

            // Always re-check the patient's current cart right before merging, so we never clobber it.
            let freshCart = cartData;
            // try {
            //     freshCart = await dispatch(getCartDetails({ patientId: selectedPatient.patientId })).unwrap();
            // } catch (e) {
            //     console.log("Falling back to existing redux cart state:", e);
            // }

            const existingHdrs = freshCart?.cartOrderHdr ? [...freshCart.cartOrderHdr] : [];
            let updatedHdrs = existingHdrs;
            const consultationId = selectedConsultation.consultationId;
            const prescriptionName = selectedConsultation.imageName;

            if (drugDtlPayloads.length > 0) {
                updatedHdrs = buildOrUpdateHdr(
                    updatedHdrs,
                    "DRUG",
                    drugDtlPayloads.map((p) => p.dtl),
                    drugDtlPayloads[0].vendor,
                    consultationId,
                    prescriptionName,
                );
            }
            if (labDtlPayloads.length > 0) {
                updatedHdrs = buildOrUpdateHdr(
                    updatedHdrs,
                    "LAB",
                    labDtlPayloads.map((p) => p.dtl),
                    labDtlPayloads[0].vendor,
                    consultationId,
                    prescriptionName,
                );
                updatedHdrs = updatedHdrs.map((item => {
                    if(item.orderType === "LAB"){
                        item.labCategory = 'External Lab Test';
                    }
                    return item;
                }))
                console.log(" updated Hdrs ",updatedHdrs);
            }

            const grandTotalAmount = updatedHdrs.reduce((sum, hdr) => sum + (hdr?.paidAmount || 0), 0);

            const payload = {
                ...(freshCart || {}),
                cartId: freshCart?.cartId,
                cartOrderHdr: updatedHdrs,
                cartType: freshCart?.cartType ?? 1,
                patientId: selectedPatient.patientId,
                paymentType: freshCart?.paymentType ?? "",
                status: 1,
                modifiedDate: getCurrentTime(),
                totalAmount: grandTotalAmount,
            };

            console.log(" cart Payload ",payload);
            // return

            if (loggedUser?.user?.country === "IN") {
                await dispatch(AddtoCart(payload));
            } else {
                await dispatch(ForeignAddtoCart(payload));
            }
            await dispatch(getCartDetails({ patientId: selectedPatient.patientId }));
            message.success("Prescription items added to cart successfully.");
        } catch (error) {
            console.log(error);
            message.error("Unable to add items to cart");
        } finally {
            setCartLoader(false);
        }
    };

    /* ---------------------------------------------------------------------- */
    /* Send to Pharmacy / Send to Lab (isAvailableForCart === "N")            */
    /* Mirrors PrescriptionsList.jsx (medicine) / PrescriptionsList.jsx (lab) */
    /* ---------------------------------------------------------------------- */

    const buildVendorRolePayload = (accountRoleType) => {
        const p = { accountRoleType, status: 1 };
        if (loggedUser?.user?.rolecode === "ACCT_ADM") {
            p.account_Id = loggedUser.user.account_Id;
        } else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
            p.account_Id = loggedUser.user.account_Id;
            p.clinic_Id = loggedUser.user.clinic_Id;
        }
        return p;
    };

    const handleOpenPharmacyPicker = async () => {
        if (nonCartableMedicines.length === 0 || !selectedConsultation) return;

        // 1. Consent gate — same as PrescriptionsList.jsx's handleDrugOrder.
        if (selectedConsultation.shareEpresWithPharmacy === "N") {
            setConsentTarget("pharmacy");
            setShowConsent(true);
            return;
        }

        // 2. Duplicate-order gate.
        if (isOrderAlreadySent(selectedConsultation.drugPrescriptionStatus)) {
            message.error("Medicine Order is Already Placed");
            return;
        }

        // 3. Validate there's an actual dispensed drug list before opening the picker.
        setPharmaCheckLoader(true);
        try {
            const medListPayload = { consultationId: selectedConsultation.consultationId, status: 1 };
            const drugList = await PharmacyService.GetDispensedDrugsDtl(medListPayload);

            if (Array.isArray(drugList?.data) && drugList.data.length === 0) {
                message.error("Unable to place order, Medicine List is empty");
                return;
            }

            const response = await ClinicService.getClinicMappedPharmacies(buildVendorRolePayload("pharmacy"));
            setPharmacyList(response.data);
            setPharmaModalOpen(true);
        } catch (e) {
            console.log(e);
            message.error("Unable to fetch pharmacies");
        } finally {
            setPharmaCheckLoader(false);
        }
    };

    const handleSelectedPharma = (selectedItem) => {
        const item = pharmacyList.find((p) => p.id === selectedItem);
        if (!item) {
            message.error("Something went wrong please try after sometime!!");
            return;
        }
        setPharmaPayload({
            ...item,
            pharmacyId: item.pharmacyId,
            pharmacyName: item.pharmacyName,
            pharmacyMailId: item.pharmacyMailId,
            pharmacyMobile: item.pharmacyMobile,
        });
    };

    const handleSendToPharmacy = async () => {
        if (!pharmaPayload?.pharmacyId) {
            message.error("Please select a pharmacy");
            return;
        }
        setPharmaSendLoader(true);
        const linkPayload = {
            consultationId: selectedConsultation.consultationId,
            patientId: selectedPatient.patientId,
            userId: loggedUser.user.userId,
            appointmentId: selectedConsultation.appointmentId,
            prescriptionShareType: "p",
            vendorId: pharmaPayload.pharmacyId,
            vendorName: pharmaPayload.pharmacyName,
            vendorMailId: pharmaPayload.pharmacyMailId,
            vendorMobile: pharmaPayload.pharmacyMobile,
            drugPrescriptionStatus: "Sent",
            rejectedPharmacyRemarks: null,
            sourceChannel: loggedUser.user.rolecode === "SUPERADMIN" ? "ADMIN" : "PRACTICEADMIN",
            orderSource:"PRESCRIPTION"
        };

        try {
            const response = await ConsultationService.SharePharmaLabAPI(linkPayload);
            if (response.data.message !== "Prescription sent successfully") {
                message.error("Medicine order is already placed");
                return;
            }
            message.success(`Medicine order sent to ${linkPayload.vendorName}`);
            setPharmaModalOpen(false);
            fetchPrescriptions();
        } catch (error) {
            message.error(error?.response?.data?.message || "Something went wrong please try after sometime!!");
        } finally {
            setPharmaSendLoader(false);
        }
    };

    const handleOpenLabPicker = async () => {
        if (nonCartableLabTests.length === 0 || !selectedConsultation) return;

        // 1. Consent gate — same as the lab PrescriptionsList's handleLabOrder.
        if (selectedConsultation.shareEpresWithDiagnostics === "N") {
            setConsentTarget("lab");
            setShowConsent(true);
            return;
        }

        // 2. Duplicate-order gate.
        if (isOrderAlreadySent(selectedConsultation.labPrescriptionStatus)) {
            message.error("Lab Order Already Placed");
            return;
        }

        // 3. Validate there's an actual lab test list before opening the picker.
        setLabCheckLoader(true);
        try {
            const labListPayload = { consultationId: selectedConsultation.consultationId, status: 1 };
            const labOrderList = await LabOrderService.GetLabTestOrderDtl(labListPayload);

            if (Array.isArray(labOrderList?.data) && labOrderList.data.length === 0) {
                message.error("Unable to place order, Lab List is empty");
                return;
            }

            const response = await ClinicService.getClinicMappedLabs(buildVendorRolePayload("lab"));
            setLabList(response.data);
            setLabModalOpen(true);
        } catch (e) {
            console.log(e);
            message.error("Unable to fetch labs");
        } finally {
            setLabCheckLoader(false);
        }
    };

    const handleLabSelect = (selectedItem) => {
        const item = labList.find((l) => l.id === selectedItem);
        if (!item) {
            message.error("Something went wrong please try after sometime!!");
            return;
        }
        setLabPayload({
            ...item,
            labId: item.labId,
            labName: item.labName,
            labMailId: item.labMailId,
            labMobile: item.labMobile,
        });
    };

    const handleSendToLab = async () => {
        if (!labPayload?.labId) {
            message.error("Please select a lab");
            return;
        }
        setLabSendLoader(true);
        const linkPayload = {
            consultationId: selectedConsultation.consultationId,
            patientId: selectedPatient.patientId,
            userId: loggedUser.user.userId,
            appointmentId: selectedConsultation.appointmentId,
            prescriptionShareType: "l",
            vendorId: labPayload.labId,
            vendorName: labPayload.labName,
            vendorMailId: labPayload.labMailId,
            vendorMobile: labPayload.labMobile,
            labPrescriptionStatus: "Sent",
            rejectedLabRemarks: null,
            sourceChannel: loggedUser.user.rolecode === "SUPERADMIN" ? "ADMIN" : "PRACTICEADMIN",
            orderSource:"PRESCRIPTION"
        };

        try {
            const response = await ConsultationService.SharePharmaLabAPI(linkPayload);
            if (response.data.message !== "Prescription sent successfully") {
                message.error("Lab order is already placed");
                return;
            }
            message.success(`Lab order sent to ${linkPayload.vendorName}`);
            setLabModalOpen(false);
            fetchPrescriptions();
        } catch (error) {
            message.error(error?.response?.data?.message || "Something went wrong please try after sometime!!");
        } finally {
            setLabSendLoader(false);
        }
    };

    /* ---------------------------------------------------------------------- */
    /* Consent (shared by pharmacy + lab "N" flows)                           */
    /* ---------------------------------------------------------------------- */

    const handleConsModCancel = () => {
        setShowConsent(false);
        setConsentTarget(null);
    };

    const sendConsentRequest = async () => {
        if (!selectedConsultation) return;
        setConsentBtnDisable(true);
        const payload = { appointmentId: selectedConsultation.appointmentId };
        try {
            await ConsentService.GetPatientConsent(payload);
            message.success("Request is Send to the patient side");
        } catch (error) {
            message.error("An error occured");
        } finally {
            setShowConsent(false);
            setConsentTarget(null);
            setConsentBtnDisable(false);
        }
    };

    /* ---------------------------------------------------------------------- */
    /* Prescription detail view                                               */
    /* ---------------------------------------------------------------------- */

    const handleViewPrescription = (e, presc) => {
        e.stopPropagation();
        setSelectedId(presc.consultationId);
        setSelectedPresc(presc);
        setPrescView(true);
    };

    const handleClosePrescView = () => {
        setPrescView(false);
        setSelectedPresc(null);
    };

    /* ---------------------------------------------------------------------- */
    /* Render                                                                  */
    /* ---------------------------------------------------------------------- */

    return (
        <div className="font-sans">
            {/* Header */}
            <h2 className="text-xl font-bold text-[#189FAA]">Your Prescription</h2>

            {/* Search */}
            <div className="mt-4">
                <label className="block text-sm font-semibold text-[#232323] mb-1">
                    Search Prescription
                </label>
                <div className="relative">
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search by doctor name, date or ID..."
                        className="w-full border rounded-md pl-3 pr-9 py-2 text-sm outline-none placeholder:text-xs placeholder:text-gray-400 focus:border-[#189FAA]"
                    />
                    <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                </div>
            </div>

            {/* Prescription list */}
            <div className="mt-3 max-h-56 overflow-y-auto scrollWidth border rounded-md">
                {loader ? (
                    <div className="flex items-center justify-center py-8">
                        <Spin size="small" tip="Loading" />
                    </div>
                ) : filteredConsultations.length === 0 ? (
                    <div className="py-6">
                        <Empty description="No prescriptions found" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </div>
                ) : (
                    filteredConsultations.map((c, idx) => {
                        const isSelected = c.consultationId === selectedId;
                        return (
                            <div
                                key={c.consultationId}
                                onClick={() => setSelectedId(c.consultationId)}
                                className={`flex items-center justify-between gap-3 px-3 py-3 cursor-pointer transition-colors ${
                                    idx !== filteredConsultations.length - 1 ? "border-b" : ""
                                } ${isSelected ? "bg-[#e6f7f8]" : "hover:bg-gray-50"}`}
                            >
                                <div className="flex items-center gap-3 min-w-0">
                                    <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#189FAA] text-white flex items-center justify-center text-xs font-bold">
                                        {getInitials(c.userName)}
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm font-semibold text-[#232323] truncate">
                                            {c.userName}
                                        </p>
                                        <p className="text-xs text-gray-400">
                                            {formatDate(c.consultationDate)} &bull; Consultation ID: {c.consultationId}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    onClick={(e) => handleViewPrescription(e, c)}
                                    className="flex-shrink-0 w-8 h-8 rounded-md border border-[#189FAA] text-[#189FAA] flex items-center justify-center hover:bg-[#189FAA] hover:text-white transition-colors"
                                    aria-label="View prescription"
                                >
                                    <FaEye size={13} />
                                </button>
                            </div>
                        );
                    })
                )}
            </div>

            {/* Medicine and Lab Test — only once a prescription is selected */}
            {selectedConsultation && (
                <>
                    <h3 className="mt-5 text-base font-bold text-[#189FAA]">Medicine and Lab Test</h3>

                    {/* Medicine */}
                    {allMedicines.length > 0 && (
                        <>
                            <div className="flex items-center justify-between mt-2">
                                <p className="text-sm font-semibold text-[#232323]">Medicine</p>
                                {/* {nonCartableMedicines.length > 0 && (
                                    <button
                                        type="button"
                                        onClick={handleOpenPharmacyPicker}
                                        disabled={pharmaCheckLoader}
                                        className="text-[11px] font-semibold text-[#189FAA] underline disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {pharmaCheckLoader ? "Checking..." : `Send to Pharmacy (${nonCartableMedicines.length})`}
                                    </button>
                                )} */}
                            </div>
                            <div className="mt-1 border rounded-md divide-y">
                                {allMedicines.map((med) => {
                                    const unavailable = med.isAvailableForCart !== "Y";
                                    return (
                                        <div
                                            key={med.id}
                                            className={`flex items-center justify-between gap-3 px-3 py-3 ${
                                                unavailable ? "opacity-50" : ""
                                            }`}
                                        >
                                            <div className="flex items-center gap-3 min-w-0">
                                                <div className="flex-shrink-0 w-9 h-9 rounded-md bg-[#fdeef0] flex items-center justify-center">
                                                    <GiMedicines className="text-[#c14a5c]" size={18} />
                                                </div>
                                                <div className="min-w-0">
                                                    <p className="text-sm font-semibold text-[#232323] truncate">
                                                        {med.drugName}
                                                    </p>
                                                    <p className="text-xs text-gray-400 truncate">
                                                        {med.composition || "Tablet"}
                                                        {med.duration ? ` \u2022 ${med.duration} day(s)` : ""}
                                                    </p>
                                                    {unavailable && (
                                                        <p className="text-[10px] text-orange-400 mt-0.5">
                                                            Send to pharmacy — not directly orderable
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="flex-shrink-0 text-right">
                                                <p className="text-sm font-semibold text-[#189FAA]">{med.dosage}</p>
                                                <p className="text-xs text-gray-400">
                                                    {AFTER_BEFORE_FOOD_LABEL[med.afterBeforeFood] || "-"}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}

                    {/* Lab Test */}
                    {allLabTests.length > 0 && (
                        <>
                            <div className="flex items-center justify-between mt-4">
                                <p className="text-sm font-semibold text-[#232323]">Lab Test</p>
                                {/* {nonCartableLabTests.length > 0 && (
                                    <button
                                        type="button"
                                        onClick={handleOpenLabPicker}
                                        disabled={labCheckLoader}
                                        className="text-[11px] font-semibold text-[#189FAA] underline disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {labCheckLoader ? "Checking..." : `Send to Lab (${nonCartableLabTests.length})`}
                                    </button>
                                )} */}
                            </div>
                            <div className="mt-1 border rounded-md divide-y">
                                {allLabTests.map((test) => {
                                    const unavailable = test.isAvailableForCart !== "Y";
                                    return (
                                        <div
                                            key={test.id}
                                            className={`flex items-center gap-3 px-3 py-3 ${
                                                unavailable ? "opacity-50" : ""
                                            }`}
                                        >
                                            <div className="flex-shrink-0 w-9 h-9 rounded-md bg-[#e6f7f8] flex items-center justify-center">
                                                <GiTestTubes className="text-[#189FAA]" size={18} />
                                            </div>
                                            <div className="min-w-0">
                                                <p className="text-sm font-semibold text-[#232323] truncate">
                                                    {test.labTestName}
                                                </p>
                                                <p className="text-xs text-gray-400">Lab Test</p>
                                                {unavailable && (
                                                    <p className="text-[10px] text-orange-400 mt-0.5">
                                                        Send to lab — not directly orderable
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}

                    {allMedicines.length === 0 && allLabTests.length === 0 && (
                        <div className="py-6">
                            <Empty description="No medicine or lab test in this prescription" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        </div>
                    )}
                </>
            )}

            {/* Footer */}
            <div className="flex justify-end gap-4 mt-6">
                <button
                    type="button"
                    onClick={handleClosePrescOrdMod}
                    className="px-5 py-2 border border-[#189FAA] font-sans text-sm font-medium text-[#189FAA] rounded-md hover:bg-[#f0fbfc] transition-colors"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={handleAddToCart}
                    disabled={
                        !selectedConsultation ||
                        cartLoader ||
                        (cartableMedicines.length === 0 && cartableLabTests.length === 0)
                    }
                    className="flex items-center gap-2 px-5 py-2 bg-[#189FAA] font-sans text-sm font-semibold text-white rounded-md hover:bg-[#157e87] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <HiOutlineShoppingCart size={16} />
                    {cartLoader ? "Adding..." : "Add To Cart"}
                </button>
            </div>

            {/* Prescription view */}
            <Modal
                open={prescView}
                onCancel={handleClosePrescView}
                style={{ top: 40 }}
                width={"70%"}
                footer={null}
                destroyOnClose
            >
                <PrescriptionDetails prescription={selectedPresc} selectedPatient={selectedPatient} />
            </Modal>

            {/* Send to Pharmacy modal */}
            <Modal
                title={<span className="text-sm font-semibold font-sans text-[#189FAA]">Medicine Order</span>}
                open={pharmaModalOpen}
                onCancel={() => setPharmaModalOpen(false)}
                footer={[]}
                destroyOnClose
            >
                <div className="flex gap-2">
                    <Select className="w-[80%]" placeholder="Select pharmacy" onChange={handleSelectedPharma}>
                        {pharmacyList?.map((p) => (
                            <Select.Option key={p.id} value={p.id}>
                                {p.pharmacyName}
                            </Select.Option>
                        ))}
                    </Select>
                    <button
                        onClick={handleSendToPharmacy}
                        disabled={pharmaSendLoader}
                        className="p-1 px-1 rounded-md bg-[#189FAA] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        Send Order
                    </button>
                </div>
            </Modal>

            {/* Send to Lab modal */}
            <Modal
                title={<span className="text-sm font-semibold font-sans text-[#189FAA]">Lab Order</span>}
                open={labModalOpen}
                onCancel={() => setLabModalOpen(false)}
                footer={[]}
                destroyOnClose
            >
                <div className="flex gap-2">
                    <Select className="w-[80%]" placeholder="Select lab" onChange={handleLabSelect}>
                        {labList?.map((l) => (
                            <Select.Option key={l.id} value={l.id}>
                                {l.labName}
                            </Select.Option>
                        ))}
                    </Select>
                    <button
                        onClick={handleSendToLab}
                        disabled={labSendLoader}
                        className="p-1 px-1 rounded-md bg-[#189FAA] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        Send Order
                    </button>
                </div>
            </Modal>

            {/* Consent modal — shared by pharmacy + lab "N" flows */}
            <Modal
                title={<span className="text-sm font-semibold font-sans text-[#189FAA]">Get Consent from patient</span>}
                open={showConsent}
                onCancel={handleConsModCancel}
                footer={[]}
                destroyOnClose
            >
                <div className="flex flex-col gap-2">
                    <div className="text-sm font-sans text-[#232323]">
                        This patient didn't give consent to share E-prescription with the{" "}
                        {consentTarget === "lab" ? "lab" : "pharmacy"}, to get consent from the patient send a request.
                    </div>
                    <button
                        onClick={sendConsentRequest}
                        className="p-1 rounded-md bg-[#189FAA] text-white text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50"
                        disabled={consentBtnDisable}
                    >
                        Send Request
                    </button>
                </div>
            </Modal>
        </div>
    );
}

export default PrescriptionCartOrder;